/* eslint-disable no-unused-vars */
import React, {useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { MdClose } from 'react-icons/md'
import TextInput from './TextInput'
import { Loading, CustomButton } from '.'
import { updateProfile } from '../redux/userSlice'
import { UserLogin } from '../redux/userSlice'
import { apiRequest, handleFileUpload } from '../utils';

const EditProfile = () => {
    const { user } = useSelector((state) => state.user)
    const dispatch = useDispatch()
    const [ errMsg, setErrMsg ] = useState("")
    const [ isSubmitting, setIsSubmitting ] = useState(false)
    //const [ picture, setPicture ] = useState(null)
    const [image, setImage] = useState([]);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        defaultValues: { ...user }
    })

    const handleImage = (e) =>{
      const file = e.target.files[0];
      setFileToBase(file);
      console.log('imagefile', file);
  }

  console.log('image', image)

  const setFileToBase = (file) =>{
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () =>{
          setImage(reader.result);
      }
  }
  

    const onSubmit = async(data) => {
      try {
        //const uri= picture && (await handleFileUpload(picture));

        const { firstName, lastName, location, profession } = data
        console.log('onsubmitdata', data)

        const res = await apiRequest({
            url: "/users/update-user",
            data: {
                firstName,
                lastName,
                location,
                profession,
                profileUrl: image ? image : user?.profileUrl?.url ?? '',
            },
            method: "PUT",
            token: user?.token,
        })

        console.log('Response:', res);

        if (res?.status === "failed") { 
            setErrMsg(res.message || "Failed to update profile.")

        } else {
            setErrMsg(res)
            const newUser = { token: res?.token, ...res?.user }
            dispatch(UserLogin(newUser))

            setTimeout(() => {
                dispatch(updateProfile(false))
            }, 3000)
        }

        setIsSubmitting(false);
        //window.location.reload()
        
    } catch (error) {
        console.log(error);
        setIsSubmitting(false);
    }
    }

    const handleClose = async() => {
        dispatch(updateProfile(false))
    }

    // const handleSelect = async(e) => {
    //     setPicture(e.target.files[0])
    // }

  return (
    <div>
        <div className='fixed z-50 inset-0 overflow-y-auto'>
            <div className='flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
                <div className='fixed inset-0 transition-opacity'>
                    <div className='absolute inset-0 bg-[#000] opacity-70'></div>
                </div>
                <span className='hidden sm:inline-block sm:align-middle sm:h-screen'></span>

                <div
                    className='inline-block align-bottom bg-primary rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full'
                    role='dialog'
                    aria-modal='true'
                    aria-labelledby='modal-headline'
                >
                    <div className='flex justify-between px-6 pt-5 pb-2'>
                        <label
                            htmlFor='name'
                            className='block font-medium text-xl text-ascent-1 text-left'
                        >
                            Edit Profile
                        </label>

                        <button className='text-ascent-1' onClick={handleClose}>
                            <MdClose size={22} />
                        </button>
                    </div>

                    <form
                        className='px-4 sm:px-6 flex flex-col gap-3 2xl:gap-6'
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <TextInput
                            name='firstName'
                            label='First Name'
                            placeholder='First Name'
                            type='text'
                            styles='w-full'
                            register={register("firstName", {
                              required: "First Name is required!",
                            })}
                            error={errors.firstName ? errors.firstName?.message : ""}
                        />

                        <TextInput
                          label='Last Name'
                          placeholder='Last Name'
                          type='lastName'
                          styles='w-full'
                          register={register("lastName", {
                            required: "Last Name do no match",
                          })}
                          error={errors.lastName ? errors.lastName?.message : ""}
                        />

                        <TextInput
                          name='profession'
                          label='Profession'
                          placeholder='Profession'
                          type='text'
                          styles='w-full'
                          register={register("profession", {
                            required: "Profession is required!",
                          })}
                          error={errors.profession ? errors.profession?.message : ""}
                        />

                        <TextInput
                          name='location'
                          label='Location'
                          placeholder='Location'
                          type='text'
                          styles='w-full'
                          register={register("location", {
                            required: "Location do no match",
                          })}
                          error={errors.location ? errors.location?.message : ""}
                        />

                        <label
                          className='flex items-center gap-1 text-base text-ascent-2 hover:text-ascent-1 cursor-pointer my-4'
                          htmlFor='imgUpload'
                        >
                          <input
                            type='file'
                            className=''
                            id='imgUpload'
                            onChange={handleImage}
                            accept='.jpg, .png, .jpeg'
                          />
                          
                        </label>
                        <img src={image} alt="" />

                        {errMsg?.message && (
                          <span
                            role='alert'
                            className={`text-sm ${
                              errMsg?.status === "failed"
                                ? "text-[#f64949fe]"
                                : "text-[#2ba150fe]"
                            } mt-0.5`}
                          >
                            {errMsg?.message}
                          </span>
                        )}

                        <div className='py-5 sm:flex sm:flex-row-reverse border-t border-[#66666645]'>
                          {isSubmitting ? (
                            <Loading />
                          ) : (
                            <CustomButton
                              type='submit'
                              containerStyles={`inline-flex justify-center rounded-md bg-blue px-8 py-3 text-sm font-medium text-white outline-none`}
                              title='Submit'
                            />
                          )}
                        </div>        
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default EditProfile